import React, { Component } from "react";

import Headbody from "../../components/head-body";
import Menu from "../../components/menu";
import Devsolucoes from "../../components/dev-solucoes";
import Footer from "../../components/footer";
import Endbody from "../../components/end-body";


class Contato extends Component {
  
    render() {
      return (
          <React.Fragment>
                <Headbody></Headbody>
                <Menu></Menu>
                <section class="header-interno padrao">
                  <div class="container">
                    <h1>Contato</h1>
                  </div>
                </section>

                <section class="conteudo-interno">
                  <div class="container">
                    <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                      <div class="row">
                        <form action="https://formsubmit.co/leonardo.arata@itechmed.com.br" method="POST" class="col-lg-10 offset-lg-1 col-11 m-auto">
                          <div class="row">
                            <div class="col-lg-6 col-12">
                              
                              <div class="mb-3">
                                  <label for="nome" class="form-label">Nome</label>
                                  <input 
                                    type="text"
                                    class="form-control"
                                    id="nome"
                                    name="name"
                                    placeholder="Digite seu nome"
                                  ></input>
                                </div>

                                <div class="mb-3">
                                  <label for="email" class="form-label">Email</label>
                                  <input 
                                    type="email"
                                    class="form-control"
                                    id="email"
                                    name="email"
                                    placeholder="Ex: seuemail@email.com"
                                  ></input>
                                </div>

                                <div class="row">
                                  <div class="col-lg-3 col-3">	
                                    <div class="mb-3">
                                      <label for="telefone" class="form-label">Telefone</label>
                                      <input 
                                        type="text"
                                        class="form-control"
                                        id="ddd"
                                        name="ddd"
                                        placeholder="DDD"
                                      ></input>
                                    </div>
                                  </div>

                                  <div class="col-lg-9 col-9">
                                    <label for="telefone" class="form-label">&nbsp;</label>
                                    <input 
                                      type="text"
                                      class="form-control"
                                      id="telefone"
                                      name="telefone"
                                      placeholder="Digite um número de telefone"
                                    ></input>
                                  </div>
                                </div>
                            </div>

                            <div class="col-lg-6 col-12">
                                <div class="mb-3">
                                  <label for="mensagem" class="form-label">Mensagem</label>
                                  <textarea
                                    class="form-control"
                                    id="mensagem"
                                    name="message"
                                    placeholder="Digite sua mensagem aqui..."
                                    cols="30" rows="10"
                                  ></textarea>
                                </div>
                            </div>
                          </div>
                          <input type="hidden" name="_captcha" value="false"></input>
                          <input type="hidden" name="_cc" value="comercial@itechmed.com.br"></input>
                          <input type="hidden" name="_next" value="https://www.itechmed.com.br/grato"></input>

                          
                            <div class="row m-auto">
                              <button type="submit" class="btn-itm">Enviar</button>
                            </div>
                        </form>
                      </div>
                    </div>
                  </div>

                </section>

                <Footer></Footer>
                <Endbody></Endbody>
          </React.Fragment>
        
      );
    }
  }

export default Contato;